module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "dashboardBloc col-lg-6 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "dashboard-container full"
  }, [_c('header', {
    staticClass: "flexContainer jc-sb"
  }, [_c('div', {
    staticClass: "blockTitle"
  }, [_c('h2', {
    staticClass: "jc-sb full"
  }, [_vm._t("title")], 2)])]), _vm._v(" "), _c('section', {
    staticClass: "dashboardWrapper flexContainer mobileNot fw-w tabletNot"
  }, [_vm._t("content-desktop")], 2), _vm._v(" "), _c('section', {
    staticClass: "mobileOnly"
  }, [_vm._t("content-mobile")], 2), _vm._v(" "), (!_vm.noFooter) ? _c('footer', {
    staticClass: "flexContainer jc-fe"
  }, [_c('div', {
    staticClass: "blockAction"
  }, [_vm._t("footer")], 2)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-320c859a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/BaseWidget.vue
// module id = 3112
// module chunks = 0